<template>
  <div v-show="show" class="ref-control-box" :class="{ 'full-screen': fullScreen }">
    <div class="title-container">
      <tabs
        :tab-list="menuList"
        :default-active="activeIndex"
        @click="handleSelect"
        class="tabs"
      ></tabs>

      <div class="operation">
        <span class="btn" :class="{ 'is-disabled': control.disabled }" @click="openRefDataDialog()">
          <i class="el-icon-plus"></i>
          关联记录
        </span>
        <span class="btn" @click="handleFullScreen">
          {{ fullScreen ? "退出全屏" : "全屏" }}
        </span>
      </div>
    </div>
    <ref-sheet-table
      :delete-visible="!control.disabled"
      :ref-control="control"
      :dataIds="dataIds"
      @delete-click="deleteRefData"
    ></ref-sheet-table>
    <ref-data-dialog
      multiple
      :control="control"
      :ref-sheet="refSheetDef"
      :ref-condition="refCondition"
      :dialog-visible.sync="refDataDialogVisible"
      :data-ids="dataIds"
      @data-created="dataCreated"
      @select="refDataSelected"
      @submit="addRefData"
    ></ref-data-dialog>
  </div>
</template>

<script>
import RefDataDialog from "@/components/Sheet/RefDataDialog"
import { getSheetInAvailableSheets } from "@/utils/sheet"
import Tabs from "@/components/UIComponents/Tab"
import RefSheetTable from "@/components/UIComponents/SheetTable/RefSheetTable"
import { getIdList } from "@/utils/common"

export default {
  name: "ref-control",
  data() {
    return {
      refSheet: {},
      activeIndex: "",
      controlVal: null,
      control: {},
      refDataDialogVisible: false,
      dataIds: [],
      menuList: [],
      fullScreen: false // 表格全屏
    }
  },
  components: {
    RefSheetTable,
    RefDataDialog,
    Tabs
  },
  props: {
    controls: Array,
    availableSheets: Array,
    onlyReuired: Boolean,
    form: Object,
    sheetId: String,
    sheetData: Object
  },
  watch: {
    form: function(newVal, oldVal) {
      this.init(this.form)
    }
  },
  computed: {
    show() {
      if (!this.onlyReuired) return true
      return this.control.required
    },
    refSheetDef() {
      return getSheetInAvailableSheets(this.availableSheets, this.control.refSheetId)
    },
    refCondition() {
      return {
        refSheetId: this.sheetId,
        refControlId: this.control._cid,
        refSheetData: this.sheetData
      }
    }
  },
  methods: {
    init() {
      if (this.controls.length === 0) return
      this.control = !this._.isEmpty(this.control) ? this.control : this.controls[0]
      this.activeIndex = this.control._cid
      if (this.controls?.length == 0) return []
      this.menuList = this.controls?.map(item => {
        return {
          label: item.name + "（" + (this.form[item._cid] || []).length + "）",
          value: item._cid
        }
      })
      this.getDataIds()
    },
    handleSelect(key) {
      this.control = this.controls.find(x => x._cid == key)
      this.getDataIds()
    },
    handleFullScreen() {
      this.fullScreen = !this.fullScreen
      this.$emit("full-screen", this.fullScreen)
    },
    refDataSelected(selected) {
      this.addRefData([selected])
    },
    addRefData(valList = []) {
      let control = [].concat(this.form[this.control._cid] || [])
      valList.forEach(item => {
        if (this.dataIds.every(x => x != item.id)) {
          control.push(item)
        }
      })
      let form = {
        _cid: this.control._cid,
        control: control
      }
      this.$emit("update", form)
      this.init()
    },
    deleteRefData(data) {
      let control = this.form[this.control._cid]
      let newCon = control.filter(x => (typeof x === "string" ? x != data.id : x.id != data.id))
      let form = {
        _cid: this.control._cid,
        control: newCon
      }
      this.$emit("update", form)
      this.init()
    },
    getDataIds() {
      this.dataIds = getIdList(this.form[this.control?._cid])
    },
    dataCreated(sheetData) {
      let control = this.form[this.control._cid] || []
      control.push(sheetData)
      let form = {
        _cid: this.control._cid,
        control: control
      }
      this.$emit("update", form)
      this.init()
    },
    openRefDataDialog() {
      if (!this.control.disabled) this.refDataDialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.ref-control-box {
  width: 100%;
  background-color: #fff;
  &.full-screen {
    width: 100vw !important;
    height: 100vh !important;
    padding: 14px 20px 0 40px !important;
  }
  .title-container {
    position: relative;
    display: flow-root;
    color: $color-font-first;
    font-size: $font-size-title-topic;
    line-height: 28px;
    &::before {
      content: "";
      position: absolute;
      left: -22px;
      width: 6px;
      height: 28px;
      border-radius: 4px;
      background-color: $color-main;
    }
    .name {
      margin-right: auto;
    }
    .operation {
      padding: 10px 0;
      float: right;
      font-size: $font-size-title-topic;
      .btn {
        font-size: $font-size-main;
        height: 28px;
        line-height: 28px;
        color: $color-main;
        cursor: pointer;
        &:hover {
          color: #66b1ff;
        }
        & + .btn {
          margin-left: 10px;
        }
        &.is-disabled {
          color: $color-font-second;
          cursor: not-allowed;
        }
      }
    }
    ::v-deep .tab {
      border-bottom: 1px solid #e4e4e4;
      .tab-title {
        margin-left: 6px;
      }
    }
  }
  ::v-deep .sheet-table {
    flex: auto;
    overflow: hidden;
    height: 630px;
  }
}
.full-screen .table-wrap {
  height: calc(100vh - 48px - 14px);
  width: 100vw;
  max-width: 100vw;
  margin-left: -40px;
  ::v-deep .el-table__body-wrapper {
    height: calc(100% - 51px);
  }
}
</style>
